import React from "react";
import { View, ActivityIndicator } from "react-native";
import { useTheme } from "styled-components/native";

interface LazyLoadFallbackProps {
  fullScreen?: boolean;
}

const LazyLoadFallback: React.FC<LazyLoadFallbackProps> = ({
  fullScreen = false,
}) => {
  const theme = useTheme();

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: fullScreen ? theme["core-01"] : "transparent",
        minHeight: fullScreen ? "100%" : 200,
      }}
    >
      <ActivityIndicator size="large" color={theme["core-05"]} />
    </View>
  );
};

export default LazyLoadFallback;
